import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { getFieldsMappingDetailsViaOperationId } from '../../api/cafmApi'
import { _Operation } from '../../components/EditFieldMapping/OrganizationDetails'
import { fetchMasterDeatils } from './MasterDataSlice'
import * as _ from 'lodash'
import { setInitialRequest } from './operationDetailsSlice'
import { setPayload } from './EditFieldMappinPayloadSlice'
// Async thunk to fetch users
export const fetchFieldMapping = createAsyncThunk<Record<string, string>[], string, { rejectValue: string }>(
  'EditFieldMapping/fetchFieldMapping',
  async (operation_id, { rejectWithValue, dispatch }) => {
    try {
      const response = await getFieldsMappingDetailsViaOperationId(operation_id!)
      const details = response.data

      // Try different possible property names for source_system
      const integrationDetail = details.integration_details?.[0]
      const sourceSystem = integrationDetail?.kone_system || integrationDetail?.source_system || 'fsm' // Prefer kone_system

      await dispatch(fetchMasterDeatils(sourceSystem))
      console.log('Using source_system:', sourceSystem)

      dispatch(
        setInitialRequest({
          integation_id: details?.integration_details[0]?.integration_id,
          api_endpoint_url: details?.api_endpoint_url,
          api_method: details?.api_method,
          object_type: details?.source_object_name,
          decider_fields_name: details?.decider_fields_details[0]?.field_name,
          decider_fields_value: _.uniq(_.map(details?.decider_fields_details, 'field_value')),
        }),
      )

      dispatch(
        setPayload({
          type: 'SET_OPERATION',
          payload: { operation_id: details.operation_id },
        }),
      )
      return details
    } catch (error) {
      return rejectWithValue(error.message)
    }
  },
)

const initialState: {
  EditFieldMapping: _Operation
  loading: boolean
  error: string | null
  selectedFieldForValueMapping: any | null
} = {
  EditFieldMapping: {
    operation_id: '',
    event_name: '',
    operation_type: '',
    usage_desc: '',
    frequency: '',
    source_object_name: '',
    dest_object_name: null,
    api_endpoint_url: '',
    api_method: '',
    api_headers: '',
    authentication_info: '',
    dependant_operations: null,
    decider_fields_details: [],
    field_mapping_details: [],
    integration_details: [],
  },
  loading: false,
  error: null,
  selectedFieldForValueMapping: null,
}

const EditFieldMappingSlice = createSlice({
  name: 'EditFieldMapping',
  initialState,
  reducers: {
    setEditFieldMapping: (state, action) => {
      state.EditFieldMapping.field_mapping_details.push(action.payload)
    },
    setUpdateEditFieldMapping: (state, action) => {
      const { field_id } = action.payload

      // Find the record
      const fineRecord = state.EditFieldMapping.field_mapping_details.find((f) => f.field_mapping_id === field_id)

      if (!_.isEmpty(fineRecord)) {
        // Create a new array without modifying state directly
        state.EditFieldMapping.field_mapping_details = state.EditFieldMapping.field_mapping_details
          .filter((f) => f.field_mapping_id !== field_id)
          .concat({ ...fineRecord, ...action.payload })
      }
    },
    setNewEditFieldMapping: (state, action) => {
      const { new_field_id } = action.payload

      // Find the record
      const fineRecord = state.EditFieldMapping.field_mapping_details.find((f) => f.new_field_id === new_field_id)

      if (!_.isEmpty(fineRecord)) {
        // Create a new array without modifying state directly
        state.EditFieldMapping.field_mapping_details = state.EditFieldMapping.field_mapping_details
          .filter((f) => f.new_field_id !== new_field_id)
          .concat({ ...fineRecord, ...action.payload })
      }
    },
    deleteFieldMapping: (state, action) => {
      const { field_mapping_id, destination_object_field_path } = action.payload

      if (field_mapping_id) {
        state.EditFieldMapping.field_mapping_details = state.EditFieldMapping.field_mapping_details.filter(
          (f) => f.field_mapping_id !== field_mapping_id,
        )
      } else {
        state.EditFieldMapping.field_mapping_details = state.EditFieldMapping.field_mapping_details.filter(
          (f) => f.destination_object_field_path !== destination_object_field_path,
        )
      }
    },
    updateEndpoint: (state, action) => {
      state.EditFieldMapping.api_endpoint_url = action.payload
    },
    updateEndpointMethod: (state, action) => {
      state.EditFieldMapping.api_method = action.payload
    },
    updateAPIHeader: (state, action) => {
      state.EditFieldMapping.api_headers = action.payload
    },
    setNewEditValueMapping: (state, action) => {
      action.payload.map((a: { [x: string]: any; new_field_id: any; new_value_mapping_id: any }) => {
        const { new_field_id, new_value_mapping_id, ...updated_value } = a

        // Find the field mapping record
        const fieldMappingIndex = state.EditFieldMapping.field_mapping_details.findIndex(
          (f) => f.new_field_id === new_field_id,
        )

        if (fieldMappingIndex !== -1) {
          let fieldMapping = state.EditFieldMapping.field_mapping_details[fieldMappingIndex]

          if (fieldMapping?.value_mapping_details && fieldMapping.value_mapping_details.length) {
            const currentMapping = fieldMapping.value_mapping_details[0].value_mapping_type

            if (currentMapping !== updated_value.value_mapping_type) {
              // Remove previous mapping
              fieldMapping = {
                ...fieldMapping,
                value_mapping_details: [],
              }

              // Add new mapping
              fieldMapping = {
                ...fieldMapping,
                value_mapping_details: [
                  {
                    new_value_mapping_id,
                    value_mapping_id: null,
                    source_value: null,
                    converted_value: null,
                    source_field_name: null,
                    value_mapping_type: updated_value.value_mapping_type,
                    destination_field_name: null,
                    ...updated_value,
                  },
                ],
              }
            } else {
              // Find the value mapping record
              const valueMappingIndex = fieldMapping.value_mapping_details!.findIndex(
                (v) => v.new_value_mapping_id === new_value_mapping_id,
              )
              if (valueMappingIndex !== -1) {
                // Update the specific value mapping entry immutably
                fieldMapping = {
                  ...fieldMapping,
                  value_mapping_details: fieldMapping.value_mapping_details!.map((v, index) =>
                    index === valueMappingIndex ? { ...v, ...updated_value } : v,
                  ),
                }
              } else {
                // If value mapping does not exist, add it
                fieldMapping = {
                  ...fieldMapping,
                  value_mapping_details: [
                    ...fieldMapping.value_mapping_details!,
                    {
                      new_value_mapping_id,
                      value_mapping_id: null,
                      source_value: null,
                      converted_value: null,
                      source_field_name: null,
                      value_mapping_type: null,
                      destination_field_name: null,
                      ...updated_value,
                    },
                  ],
                }
              }
            }
          } else {
            // If value mapping does not exist, add it
            fieldMapping = {
              ...fieldMapping,
              value_mapping_details: [
                {
                  new_value_mapping_id,
                  value_mapping_id: null,
                  source_value: null,
                  converted_value: null,
                  source_field_name: null,
                  value_mapping_type: null,
                  destination_field_name: null,
                  ...updated_value,
                },
              ],
            }
          }

          // Update state immutably
          state.EditFieldMapping.field_mapping_details = state.EditFieldMapping.field_mapping_details.map((f, index) =>
            index === fieldMappingIndex ? fieldMapping : f,
          )
        }
      })
    },
    setExistingEditValueMapping: (state, action) => {
      action.payload.map((a: { [x: string]: any; new_field_id: any; value_mapping_id: any }) => {
        const { field_mapping_id, value_mapping_id, ...updated_value } = a

        // Find the field mapping record
        const fieldMappingIndex = state.EditFieldMapping.field_mapping_details.findIndex(
          (f) => f.field_mapping_id === field_mapping_id,
        )

        if (fieldMappingIndex !== -1) {
          let fieldMapping = state.EditFieldMapping.field_mapping_details[fieldMappingIndex]

          if (fieldMapping?.value_mapping_details && fieldMapping.value_mapping_details.length) {
            const currentMapping = fieldMapping.value_mapping_details[0].value_mapping_type

            if (currentMapping !== updated_value.value_mapping_type) {
              // Remove previous mapping
              fieldMapping = {
                ...fieldMapping,
                value_mapping_details: [],
              }

              // Add new mapping
              fieldMapping = {
                ...fieldMapping,
                value_mapping_details: [
                  {
                    value_mapping_id,
                    source_value: null,
                    converted_value: null,
                    source_field_name: null,
                    value_mapping_type: updated_value.value_mapping_type,
                    destination_field_name: null,
                    ...updated_value,
                  },
                ],
              }
            } else {
              // Find the value mapping record by value_mapping_id
              const valueMappingIndex = fieldMapping.value_mapping_details!.findIndex(
                (v) => v.value_mapping_id === value_mapping_id,
              )
              if (valueMappingIndex !== -1) {
                // Update the specific value mapping entry immutably
                fieldMapping = {
                  ...fieldMapping,
                  value_mapping_details: fieldMapping.value_mapping_details!.map((v, index) =>
                    index === valueMappingIndex ? { ...v, ...updated_value } : v,
                  ),
                }
              } else {
                // If value mapping does not exist, add it
                fieldMapping = {
                  ...fieldMapping,
                  value_mapping_details: [
                    ...fieldMapping.value_mapping_details!,
                    {
                      value_mapping_id,
                      source_value: null,
                      converted_value: null,
                      source_field_name: null,
                      value_mapping_type: null,
                      destination_field_name: null,
                      ...updated_value,
                    },
                  ],
                }
              }
            }
          } else {
            // If value mapping does not exist, add it
            fieldMapping = {
              ...fieldMapping,
              value_mapping_details: [
                {
                  value_mapping_id,
                  source_value: null,
                  converted_value: null,
                  source_field_name: null,
                  value_mapping_type: null,
                  destination_field_name: null,
                  ...updated_value,
                },
              ],
            }
          }

          // Update state immutably
          state.EditFieldMapping.field_mapping_details = state.EditFieldMapping.field_mapping_details.map((f, index) =>
            index === fieldMappingIndex ? fieldMapping : f,
          )
        }
      })
    },
    resetMatchField: (state) => {
      state.EditFieldMapping.field_mapping_details.map((f) => {
        f.source_object_field_name = 'Status'
      })
    },
    setSelectedFieldForValueMapping: (state, action) => {
      state.selectedFieldForValueMapping = action.payload
    },
    clearSelectedFieldForValueMapping: (state) => {
      state.selectedFieldForValueMapping = null
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchFieldMapping.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchFieldMapping.fulfilled, (state, action) => {
        state.loading = false
        state.EditFieldMapping = action.payload as unknown as _Operation
      })
      .addCase(fetchFieldMapping.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload as string
      })
  },
})

export const {
  setEditFieldMapping,
  setUpdateEditFieldMapping,
  setNewEditFieldMapping,
  deleteFieldMapping,
  updateEndpoint,
  updateEndpointMethod,
  updateAPIHeader,
  setNewEditValueMapping,
  setExistingEditValueMapping,
  resetMatchField,
  setSelectedFieldForValueMapping,
  clearSelectedFieldForValueMapping,
} = EditFieldMappingSlice.actions
export default EditFieldMappingSlice.reducer
